/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lp_Login_Subscribetitle1Inputs */

const en_lp_login_subscribetitle1 = /** @type {(inputs: Lp_Login_Subscribetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe digitally`)
};

/**
* | output |
* | --- |
* | "Subscribe digitally" |
*
* @param {Lp_Login_Subscribetitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_subscribetitle1 = /** @type {((inputs?: Lp_Login_Subscribetitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Subscribetitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_subscribetitle1(inputs)
});
export { lp_login_subscribetitle1 as "lp_login_subscribeTitle" }